import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserContextService } from '../core/services/user-context.service';
import { baseRoutePrefix, buildRoutePrefix } from '../core/util';
import { SharedService } from '../core/services/shared-service';

@Component({
  selector: 'app-dashboard-redirect',
  template: '<router-outlet></router-outlet>',
})
export class DashboardRedirectComponent implements OnInit {
  constructor(
    private router: Router,
    private orgService: UserContextService,
    private sharedService: SharedService
  ) {}

  ngOnInit(): void {
    const instance = this.orgService?.CurrentInstance;
    if (instance?.ID) {
      // first check to see if the current route has a valid prefix (e.g. instance info)
      // if it does, leave it alone, otherwise, redirect to a default /chat url after the instance prefix stuff
      if (this.router.url.indexOf(baseRoutePrefix()) === -1) {
        const prefix = buildRoutePrefix(instance.ID);
        this.router.navigate([`${prefix}/chat`]);
      }
    } else if (this.orgService.DoesOrganizationHaveActiveInstances()) {
      // If the organization has instances, but none were loaded for the current user, redirect to the no-instance page
      if (this.router.url.indexOf('no-instance') === -1) {
        this.router.navigate(['/dashboard/no-instance']);
      }
    }
    else {
      this.sharedService.AccessDenied = true;
    }
  }
}
